import { DdEventCategory, DdEventType } from '../types';
import { Logger } from './rumEvents';

export enum NativeGlsActionNames {
  ENTERED = '[GW][NATIVE_GLS] Fetch path entered',
  SUCCESS = '[GW][NATIVE_GLS] Fetch success',
  FAILED = '[GW][NATIVE_GLS] Fetch failed',
  MALFORMED_FALLBACK = '[GW][NATIVE_GLS] Malformed payload fallback',
}

export const ddNativeGlsEntered = () =>
  Logger.rumAction({
    name: NativeGlsActionNames.ENTERED,
    description: 'Android native GLS fetch path entered',
    useCase: DdEventCategory.GameLaunch,
    eventType: DdEventType.Info,
  });

export const ddNativeGlsSuccess = () =>
  Logger.rumAction({
    name: NativeGlsActionNames.SUCCESS,
    description: 'Native getGameData returned a usable launch payload',
    useCase: DdEventCategory.GameLaunch,
    eventType: DdEventType.Success,
  });

export const ddNativeGlsFailed = (context?: Record<string, unknown>) =>
  Logger.rumAction({
    name: NativeGlsActionNames.FAILED,
    description: 'Native getGameData threw, falling back to the GLS fetch',
    useCase: DdEventCategory.GameLaunch,
    eventType: DdEventType.Error,
    context,
  });

export const ddNativeGlsMalformedFallback = () =>
  Logger.rumAction({
    name: NativeGlsActionNames.MALFORMED_FALLBACK,
    description:
      'Native getGameData payload malformed, falling back to the GLS fetch',
    useCase: DdEventCategory.GameLaunch,
    eventType: DdEventType.Error,
  });
